import { createSelector } from 'reselect';

const getPointsState = state => state.points;

export const pointLoadingSelector = createSelector(
    [getPointsState],
    pointsState => pointsState.loading
);

const getSuppliersState = state => state.suppliers;
export const suppliersSelector = createSelector(
    [getSuppliersState],
    suppliersState => suppliersState.items
)
export const suppliersLoadingSelector = createSelector(
    [getSuppliersState],
    suppliersState => suppliersState.loading
)

export const inventoryFormsLoadingSelector = state => state.inventoryForms.loading;

export const inventoryFormSelector = (state, id) =>
    state.inventoryForms.formsById[id] || state.inventoryForms.form;

export const inventoryFormLoadingSelector = (state, id) =>
    state.inventoryForms.loadingById[id] || false;

export const inventoryFormSavingSelector = (state, id) =>
    state.inventoryForms.savingById[id] || state.inventoryForms.saving || false;

const getReasonState = state => state.reasons;
export const reasonsSelector = createSelector(
    [getReasonState],
    reasonsState => reasonsState.items
)
export const reasonsLoadingSelector = createSelector(
    [getReasonState],
    reasonsState => reasonsState.loading
)

export const goodsSelector = createSelector(
    state => state.writeoff.goods,
    goods => goods || []
);
